import clsx from 'clsx'
import { LoginAsDifferentUserLink, Rule } from 'components/core-v2'
import { TwoFactorForm } from 'components/core-v2/organisms/forms'
import { Link } from 'react-router-dom'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'
import classes from './two-factor.module.scss'

const MainElement = () => (
  <>
    <div className={classes.card}>
      <TwoFactorForm />
    </div>
    <div className={clsx('mt-8', classes.loginAsDifferentUser)}>
      <LoginAsDifferentUserLink />
    </div>
    <Rule className="my-6" />
    <div className={classes.help}>
      <p className="mt-6 mb-0">{COPY.twoFactor.unableToLogin}</p>
      <Link to={`mailto:${COPY.twoFactor.email}`}>{COPY.twoFactor.email}</Link>
    </div>
  </>
)

export const TwoFactor = () => (
  <TwoColumnWithImage mainElement={<MainElement />} title={COPY.login.title} width="420px" />
)
